import React from 'react'

export class Empty extends React.Component {
  render() {
    return <div />
  }
}

export default Empty
